<template>
    <section class="search_results mb-5">
        <div class="container mt-5">
            <div class="row">
                <div class="col-md-3 pl-0">
                    <div class="product-categories mb-3">  
                        <div class="product-categories-list">
                            <h4>Product Categories</h4>
                            <div class="bottom-br"></div>
                            <b-form-group v-slot="{ ariaDescribedby }"
                                v-if="category == undefined">
                                <b-form-checkbox-group
                                    v-model="selectedCategories"
                                    :aria-describedby="ariaDescribedby"
                                    name="category"
                                    @change="getProducts()"
                                    stacked>
                                    <b-form-checkbox :value="category.id" 
                                        v-for="category in categories"
                                        :key="category.id">
                                        {{ category.name }}
                                    </b-form-checkbox>    
                                </b-form-checkbox-group>
                            </b-form-group>
                            <ul v-if="category !== undefined">
                                <li v-for="category in categories">
                                    <a :href="appUrl+'/products/'+category.id+'/category'">
                                        {{ category.name }}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="product-categories mb-3" v-if="maxPrice > 0 && minPrice < maxPrice">  
                        <div class="product-categories-list">
                            <h4>Price</h4>
                            <div class="bottom-br"></div>
                            <b-form-input id="range-1" 
                                v-model="selectedPrice" 
                                type="range" 
                                :min="minPrice" 
                                :max="maxPrice"
                                @change="getProducts()">        
                            </b-form-input>
                            <div class="mt-2">
                                <i class="fa fa-rupee-sign"></i> 
                                {{ selectedPrice }}
                            </div>
                        </div>
                    </div>
                    <div class="product-categories">  
                        <div class="product-categories-list">
                            <h4>Product Brands</h4>
                            <div class="bottom-br"></div>
                            <b-form-group v-slot="{ ariaDescribedby }"
                                v-if="brand == undefined">
                                <b-form-checkbox-group
                                    v-model="selectedBrands"
                                    :aria-describedby="ariaDescribedby"
                                    name="brand"
                                    @change="getProducts()"
                                    stacked>
                                    <b-form-checkbox :value="brand.id" 
                                        v-for="brand in brands"
                                        :key="brand.id">
                                        {{ brand.name }}
                                    </b-form-checkbox>    
                                </b-form-checkbox-group>
                            </b-form-group>
                            <ul v-if="brand !== undefined">
                                <li v-for="brand in brands">
                                    <a :href="appUrl+'/products/'+brand.id+'/brand'">
                                        {{ brand.name }}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-md-9 mb-3" v-if="products.data.length > 0">
                    <div class="row g-1">
                        <div class="col-md-4 mb-3" v-for="product in products.data">
                            <div class="card">
                                <a :href="appUrl+'/products/'+product.id">
                                    <div class="text-center"
                                        v-if="product.images[0]"> 
                                        <img :src="appUrl+'/'+product.images[0].image_path" 
                                            :alt="product.title" 
                                            class="img-fluid" 
                                            width="100%"> 
                                    </div>
                                    <div class="text-center"
                                        v-else> 
                                        <img :src="appUrl+'/images/default-image.jpg'" 
                                            :alt="product.title" 
                                            class="img-fluid"
                                            width="100%"> 
                                    </div>
                                </a>
                                <div class="product-details m-3">
                                    <a :href="appUrl+'/products/'+product.id">
                                        <span class="products-name d-block">{{ product.title }}</span>
                                    </a>
                                    <span class="products-price strike"
                                        v-if="product.offer_price">
                                        <i class="fa fa-rupee-sign"></i> 
                                        {{ product.mrp }}
                                    </span>
                                    <span class="products-price"
                                        v-else>
                                        <i class="fa fa-rupee-sign"></i> 
                                        {{ product.mrp }}
                                    </span>
                                    <span class="products-price"
                                        v-if="product.offer_price">
                                        <i class="fa fa-rupee-sign"></i> 
                                        {{ product.offer_price }}
                                    </span>
                                    <div class="my-2 text-center">
                                        <dl class="param param-inline">
                                            <dd>
                                                <b-form-spinbutton id="product-quantity"
                                                    class="text-center"
                                                    size="lg" 
                                                    v-model="product.cart_quantity"
                                                    min="0"
                                                    :max="product.min_quantity * 10"
                                                    :step="product.min_quantity"
                                                    @change="addToCart(product.id, $event)"
                                                    inline></b-form-spinbutton>
                                            </dd>
                                        </dl>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row my-3">
                        <div class="col-md-12">
                            <pagination :data="products" @pagination-change-page="getProducts"></pagination>
                        </div>
                    </div>
                </div>
                <div class="col-md-9 mb-3" v-else>
                    <div class="row g-1">
                        <div class="col-md-12 mb-3">
                            <div class="card">
                                <div class="text-center">
                                    <p>Sorry, no products found.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bottom-br"></div>
        </div>
        <notifications group="cart" />
    </section>
</template>
<script>
    export default {
        props: {
            category: {
                type: Number
            },
            brand: {
                type: Number
            }
        },
        data() {
            return {
                selectedPrice: 0,
                minPrice: 0,
                maxPrice: 0,
                products: { 'data': [] },
                categories: [],
                brands: [],
                selectedCategories: [],
                selectedBrands: [],
                appUrl: document.head.querySelector('meta[name="app-url"]').content,
            };
        },
        mounted() {
            this.getCategories();
            this.getBrands();
            this.getProducts();
        },
        methods: {
            getProducts(page = 1) {
                var requestUrl = 'api/get-products';
                var that = this;
                if (that.category !== undefined) {
                    requestUrl = 'api/get-products/'+that.category+'/category';
                }
                if (that.brand !== undefined) {
                    requestUrl = 'api/get-products/'+that.brand+'/brand';
                }
                axios.post(requestUrl, {
                    categories: that.selectedCategories,
                    brands: that.selectedBrands,
                    price: that.selectedPrice,
                    page: page,
                })
                .then(function(response) {
                    that.products = response.data.products;
                    that.minPrice = response.data.minPrice;
                    that.maxPrice = response.data.maxPrice;
                    if (that.selectedPrice == 0) {
                        that.selectedPrice = response.data.maxPrice;
                    }
                })
                .catch(function (response) {
                    console.log(response);
                    alert('Something went wrong, please try again.');
                });
            },
            getCategories() {
                var that = this;
                axios.get('api/get-all-categories')
                .then(function(response) {
                    that.categories = response.data.categories;
                })
                .catch(function (response) {
                    console.log(response);
                    alert('Something went wrong, please try again.');
                });
            },
            getBrands() {
                var that = this;
                axios.get('api/get-all-brands')
                .then(function(response) {
                    that.brands = response.data.brands;
                })
                .catch(function (response) {
                    console.log(response);
                    alert('Something went wrong, please try again.');
                });
            },
            addToCart(id, quantity) {
                var that = this;
                axios.post('api/add-to-cart', {
                    id: id,
                    quantity: quantity,
                })
                .then(function(response) {
                    if (response.data.success) {
                        that.$notify({
                            group: 'cart',
                            title: 'Success',
                            type: 'success',
                            text: response.data.message
                        });
                    } else {
                        that.$notify({
                            group: 'cart',
                            title: 'Error',
                            type: 'error',
                            text: response.data.message
                        });
                    }
                })
                .catch(function (response) {
                    console.log(response);
                    alert('Something went wrong, please try again.');
                });
            }
        }
    };
</script>
